import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import { environment } from '../../environments/environment';
import {MsalService} from '@azure/msal-angular';
const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };


@Injectable()
export class LogoIconMgmtService {

  constructor(private _http: HttpClient,private adal: MsalService) {
  }

  uploadImage(imageDetails): any {

    return this._http.post(environment.APIEndpoint + 'api/LogoIconMgmt/UploadImage', imageDetails)
      .map((res: Response) => res)
      .catch(this._errorHandler);
  }

  getImageType(): any {
    return this._http.get(environment.APIEndpoint + 'api/LogoIconMgmt/GetImageType')
      .map((res: Response) => res)
      .catch(this._errorHandler);
  }

  getIconCategoryList(): any {
    return this._http.get(environment.APIEndpoint + 'api/LogoIconMgmt/GetIconCategoryList', httpOptions)
      .map((res: Response) => res)
      .catch(this._errorHandler);
  }

  getLogoIconList(): any {
    return this._http.get(environment.APIEndpoint + 'api/LogoIconMgmt/GetLogoIconList', httpOptions)
      .map((res) => res)
      .catch(this._errorHandler);
  }

  getLogoList(): any {
    return this._http.get(environment.APIEndpoint + 'api/LogoIconMgmt/GetLogoList', httpOptions)
      .map((res) => res)
      .catch(this._errorHandler);
  }

  
  addCategory(userEmail):any {
    return this._http.post(environment.APIEndpoint + 'api/LogoIconMgmt/AddNewCategory', userEmail)
    .map((res: Response) => res);
}

  deleteImage(logo): any {
    return this._http.patch(environment.APIEndpoint + 'api/LogoIconMgmt/DeleteImage',logo)
      .map((res) => res)
      .catch(this._errorHandler);
  }

  deleteCategories(categoryId: any): any {
    return this._http.delete(environment.APIEndpoint + 'api/LogoIconMgmt/DeleteCategory?categoryId=' + categoryId)
      .map((res) => res)
      .catch(this._errorHandler);
  }

  downloadImage(logo : any): Observable<Blob> {
    return this._http.get(environment.APIEndpoint + 'api/LogoIconMgmt/DownloadImage?imageLink=' + logo.imageLink, {
      responseType: 'blob'
    })
      .map((res) => res)
      .catch(this._errorHandler);
  }

  /*downloadImage(logo) {
        
    return Observable.create((observer: any) => {

        let xhr = new XMLHttpRequest();
      xhr.open('GET', environment.APIEndpoint + 'api/LogoIconMgmt/DownloadImage?imageLink=' + logo.imageLink);
        xhr.setRequestHeader('Content-type', 'application/json');
        xhr.responseType = 'blob';
        const urls=environment.APIEndpoint + 'api/LogoIconMgmt/DownloadImage?imageLink=' + logo.imageLink;
        let token = sessionStorage.getItem('msal.idtoken'); 
        
          xhr.setRequestHeader('Authorization', 'Bearer ' + token);
          xhr.onreadystatechange = function () { 

            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    var contentType = 'arraybuffer';
                    var blob = new Blob([xhr.response], { type: contentType });
                    observer.next(blob);
                    observer.complete();
                } else {

                    observer.error(xhr.response);
                }
            }
        }
      xhr.send();
        });
  }*/

  checkLogoName(logoName): any {
    return this._http.get(environment.APIEndpoint + 'api/LogoIconMgmt/CheckLogoName?logoName=' + logoName)
      .map((res: Response) => res)
      .catch(this._errorHandler);
  }

  checkIconName(iconName): any {
    return this._http.get(environment.APIEndpoint + 'api/LogoIconMgmt/CheckIconName?logoName=' + iconName)
      .map((res: Response) => res)
      .catch(this._errorHandler);
  }
  _errorHandler(error: Response) {
    return Observable.throw(error || 'Server Error');
  }

  
  updateIconCategory(categoryDetails): any {

    return this._http.post(environment.APIEndpoint + 'api/LogoIconMgmt/UpdateIconCategory', categoryDetails)
      .map((res: Response) => res)
      .catch(this._errorHandler);
  }
}
